import { lerp } from './utils';

class Cursor {
    constructor() {
        this.el = document.querySelector('[data-cursor]');
        this.cursorEasingDefault = 0.25;
        this.cursorEasingSlow = 0.1;
        this.offset = 30;

        this.data = {
            mouse: {
                x: 0,
                y: 0
            },
            current: {
                x: 0,
                y: 0
            },
            last: {
                x: 0,
                y: 0
            },
            ease: this.cursorEasingDefault,
            dist: 100,
            fx: {
                diff: 0,
                acc: 0,
                velo: 0,
                scale: 0
            }
        };

        this.bounds = {
            h: 0,
            a: 0
        };

        this.rAF = null;
        this.targets = null;

        this.run = this.run.bind(this);
        this.mousePos = this.mousePos.bind(this);

        this.state = {
            stick: false
        };

        document.addEventListener('setCursorElements', () => {
            this.setCursorElements();
        });

        this.raf();
    }

    setCursorElements() {
        // this.hideCursorElements = [...document.querySelectorAll('.hide-cursor')];
        // this.activeCursorElements = [...document.querySelectorAll('.button, a:not(.text-cursor), .active-cursor')];
        this.iconCursorElements = document.querySelectorAll('.icon-cursor');
        this.textCursorElements = document.querySelectorAll('.text-cursor');
        this.cursorTextElement = this.el.querySelector('.text');
        this.addEventListeners();
    }

    mousePos(e) {
        this.data.current.x = e.clientX + this.offset;
        this.data.current.y = e.clientY + this.offset;
    }

    run() {
        this.data.last.x = lerp(this.data.last.x, this.data.current.x, this.data.ease);
        this.data.last.y = lerp(this.data.last.y, this.data.current.y, this.data.ease);

        this.data.fx.diff = this.data.current.x - this.data.last.x;
        this.data.fx.acc = this.data.fx.diff / window.innerWidth;
        this.data.fx.velo = +this.data.fx.acc;
        this.data.fx.scale = 1 - Math.abs(this.data.fx.velo * 2);

        this.el.style.transform = `translate3d(${this.data.last.x}px, ${this.data.last.y}px, 0) scale(${this.data.fx.scale})`;

        this.raf();
    }

    raf() {
        this.rAF = requestAnimationFrame(this.run);
    }

    addEventListeners() {
        window.addEventListener('pointermove', this.mousePos, { passive: true });
        // window.addEventListener('mousemove', this.mousePos, { passive: true });

        document.addEventListener('setCursorIcon', ({ detail }) => {
            this.el.dataset.icon = detail.icon;
        });

        document.addEventListener('setCursorText', ({ detail }) => {
            this.cursorTextElement.innerHTML = detail.text;
        });

        // this.hideCursorElements.forEach((element) => {
        //     element.addEventListener('pointerover', (event) => {
        //         document.body.classList.add('hide-cursor');
        //     });
        //     element.addEventListener('pointerout', (event) => {
        //         document.body.classList.remove('hide-cursor');
        //     });
        // });

        // this.activeCursorElements.forEach((element) => {
        //     element.addEventListener('pointerover', (event) => {
        //         document.body.classList.add('active-cursor');
        //     });
        //     element.addEventListener('pointerout', (event) => {
        //         document.body.classList.remove('active-cursor');
        //     });
        // });

        this.iconCursorElements.forEach((element) => {
            element.addEventListener('pointerover', (event) => {
                const icon = event.target.dataset.icon;
                console.log('icon', icon);
                if (icon) {
                    this.el.dataset.icon = icon;
                    document.body.classList.add('icon-cursor');
                } else {
                    this.el.dataset.icon = '';
                    document.body.classList.remove('icon-cursor');
                }
            });
            element.addEventListener('pointerout', () => {
                // const icon = event.target.dataset.icon;
                this.el.dataset.icon = '';
                document.body.classList.remove('icon-cursor');
            });
        });

        this.textCursorElements.forEach((element) => {
            element.addEventListener('pointerover', (event) => {
                const text = event.target.dataset.text;
                if (text) {
                    this.data.ease = this.cursorEasingSlow;
                    this.cursorTextElement.innerHTML = text;
                    document.body.classList.add('text-cursor');
                } else {
                    document.body.classList.remove('text-cursor');
                }
            });
            element.addEventListener('pointerout', () => {
                this.data.ease = this.cursorEasingDefault;
                document.body.classList.remove('text-cursor');
            });
        });
    }
}

window.Cursor = new Cursor();
